require('./SearchList.less');

var Base = require('front/components/Base/Base');

var _ = require('underscore/underscore.js');

var SearchItem = require('front/components/SearchComponents/SearchItem');


module.exports = Base.extend({

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'SearchItem': {selector: '.SearchItem', viewConstructor: SearchItem}
    },


    initialize: function (options) {
        this.options = options || {};

        _.extend(this, options);

        Base.prototype.initialize.call(this, options);

        this.viewsRegistration();
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SearchComponents/SearchList.js
// module id = 241
// module chunks = 0